<template>
    <v-table fixed-header height="80vh">
        <thead>
            <tr>
                <th class="text-center white">
                    ID
                </th>
                <th class="text-center white">
                    Arabe
                </th>
                <th class="text-center white">
                    Phonétique
                </th>
                <th class="text-center white">
                    Audio
                </th>
                <th class="text-center white">
                    Tentative
                </th>
                <th class="text-center white">
                    Vérifier
                </th>
                <th class="text-center white">
                    Voir réponse
                </th>
                <th class="text-center white">
                    Traduction
                </th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="nom in noms" :key="nom.id" :style="nom.color">
                <td>{{ nom.index }}</td>
                <td>{{ nom.arabe }}</td>
                <td>{{ nom.phonetique }}</td>
                <td>
                    <audio id="myAudio" controls>
                        <source :src="createAudioUrl(nom.audio)" type="audio/mpeg">
                        Your browser does not support the audio element.
                    </audio>
                </td>
                <td>
                    <v-text-field class="h-50" label="Traduction" variant="underlined" density="compact"
                        style="width: 200px;" v-model="nom.reponse" />
                </td>
                <td>
                    <v-btn @click="submitReponse(nom)" icon="mdi-vuetify">
                        <svg-icon type="mdi" :path="iconHelp"></svg-icon>
                    </v-btn>
                </td>
                <td>
                    <v-btn @click="seeReponse(nom)" icon="mdi-vuetify">
                        <svg-icon type="mdi" :path="iconCheck"></svg-icon>
                    </v-btn>
                </td>
                <td v-if="nom.showReponse">
                    <div v-for="traduction in nom.francais" :key="traduction">
                        {{ traduction }}
                    </div>
                </td>
            </tr>
        </tbody>
    </v-table>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiCheck, mdiHelp } from '@mdi/js';

export default {
    name: 'ListeResultats',
    components: {
        SvgIcon
    },
    props: {
        nomsProp: Array
    },
    data() {
        return {
            noms: this.nomsProp,
            nom: {},
            reponse: "",
            iconCheck: mdiCheck,
            iconHelp: mdiHelp
        }
    },
    watch: {
        // whenever question changes, this function will run
        nomsProp: {
            handler: function (newVal) {
                this.noms = newVal
            },
            deep: true
        }
    },
    mounted() {

    },
    methods: {
        createAudioUrl(url) {
            return require('../assets/audio/' + url)
        },
        compareTwoStrings(first, second) {
            first = first.replace(/\s+/g, '')
            second = second.replace(/\s+/g, '')

            if (first === second) return 1; // identical or empty
            if (first.length < 2 || second.length < 2) return 0; // if either is a 0-letter or 1-letter string

            let firstBigrams = new Map();
            for (let i = 0; i < first.length - 1; i++) {
                const bigram = first.substring(i, i + 2);
                const count = firstBigrams.has(bigram)
                    ? firstBigrams.get(bigram) + 1
                    : 1;

                firstBigrams.set(bigram, count);
            }

            let intersectionSize = 0;
            for (let i = 0; i < second.length - 1; i++) {
                const bigram = second.substring(i, i + 2);
                const count = firstBigrams.has(bigram)
                    ? firstBigrams.get(bigram)
                    : 0;

                if (count > 0) {
                    firstBigrams.set(bigram, count - 1);
                    intersectionSize++;
                }
            }

            return (2.0 * intersectionSize) / (first.length + second.length - 2);
        },
        submitReponse(nom) {
            let isCorrect = false

            nom.francais.forEach(nomFr => {
                if (this.compareTwoStrings(nomFr.toLowerCase(), nom.reponse.toLowerCase()) > 0.75) {
                    isCorrect = true

                    nom.color = {
                        backgroundColor: "green"
                    }
                }
            });

            if (!isCorrect) {
                nom.color = {
                    backgroundColor: "red"
                }
            }
        },
        seeReponse(nom) {
            nom.showReponse = true

            console.log("ffff ", nom.color.backgroundColor)

            if (nom.color.backgroundColor != "green") {
                nom.color = {
                    backgroundColor: "rgb(47, 114, 129)"
                }
            }
        }
    }
}
</script>

<style scoped>
.tab {
    border-radius: 5px;
}

.white {
    background-color: white;
}
</style>
